module.exports = __webpack_public_path__ + "img/top-left.a6589d00.png";